export class Confirmation {
    UserId: string;
    Code: string;

    constructor(userid, code) {
        this.UserId = userid;
        this.Code = code;
    }
}
